export default __webpack_public_path__ + "static/info_2-fcd6a7a9a170da4d572c11ea12c89882.png";